"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

const useResize = (callback, immediatelyInvoke = true) => {
  (0, _react.useEffect)(() => {
    const fn = () => callback();

    if (immediatelyInvoke) {
      fn();
    }

    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
};

var _default = useResize;
exports.default = _default;
module.exports = exports.default;